"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userContactMock = void 0;
const userContactMock = (userContact) => ({
    carrierId: '12asdf',
    email: 'john_doe@gmail.com',
    firstName: 'John',
    fullName: 'John Doe',
    jobTitle: 'Manager',
    lastName: 'Doe',
    phone: '+40123456789',
    ...userContact
});
exports.userContactMock = userContactMock;
